import usePosOrderDeliveryMethod from "../atoms/usePosOrderDeliveryMethodAtom";
import { useSetPosOrderPayment } from "../atoms/usePosOrderPaymentAtom";
import { DeliveryMethods, None, PaymentMethodEnum } from "../utils/enum";
import { objectIsEmpty } from "../utils/helpers";
import useIsWaiter from "./useIsWaiter";
import usePosSettingsHook from "./usePosSettingsHook";

const usePosOrderStandardHook = () => {
  const { settings } = usePosSettingsHook();
  const isWaiter = useIsWaiter();
  const setPosOrderPayment = useSetPosOrderPayment();
  const [deliveryMethod, setPosOrderDeliveryMethod] =
    usePosOrderDeliveryMethod();

  const setStandardPaymentMethod = (
    customDeliveryMethod?: number,
    customPaymentMethod?: number,
  ) => {
    if (customPaymentMethod) {
      return setPosOrderPayment(customPaymentMethod);
    }

    setPosOrderPayment(
      (customDeliveryMethod ||
        deliveryMethod ||
        settings.standard_delivery_method) === DeliveryMethods.DINE_IN
        ? PaymentMethodEnum.PAYMENT_METHOD_NOT_KNOWN_YET
        : settings?.standard_payment_method,
    );
  };

  const setStandardDeliveryMethod = (
    afterPost = false,
    customDeliveryMethod?: number,
  ) => {
    const defaultDeliveryMethod =
      customDeliveryMethod ??
      settings.delivery_method_options?.[0] ??
      DeliveryMethods.POS_ORDER;

    if (customDeliveryMethod) {
      return setPosOrderDeliveryMethod(customDeliveryMethod);
    }
    if (isWaiter) {
      return setPosOrderDeliveryMethod(DeliveryMethods.DINE_IN);
    }
    if (afterPost) {
      if (settings?.reset_delivery_method) {
        return setPosOrderDeliveryMethod(
          settings?.standard_delivery_method === None.NONE
            ? defaultDeliveryMethod
            : settings?.standard_delivery_method,
        );
      }
      return;
    } else {
      if (objectIsEmpty(settings)) {
        return;
      }

      setPosOrderDeliveryMethod(
        settings.standard_delivery_method === None.NONE
          ? settings.reset_delivery_method
            ? DeliveryMethods.POS_ORDER
            : deliveryMethod || defaultDeliveryMethod
          : settings.standard_delivery_method || defaultDeliveryMethod,
      );
    }
  };

  return {
    setStandardPaymentMethod: setStandardPaymentMethod,
    setStandardDeliveryMethod: setStandardDeliveryMethod,
  };
};

export default usePosOrderStandardHook;
